/*
 * bb-deeplink-add.js (Moshe, 2026-10-30)
 *
 * Lets any page link into Build a Box with an item already in the box:
 *   /pages/build-a-box?add=<variant id | product id | handle>
 * Works with the builder's own parameters, e.g.
 *   /pages/build-a-box?occasion=holiday&add=<id>   (Holiday tab + item)
 *   /pages/build-a-box?new=1&add=<id>              (fresh box + item)
 * Used by the item row on the holiday collection page
 * (sections/holiday-build-box.liquid).
 *
 * Loaded LAST in snippets/bb-assets.liquid (both script lists), so BBStore,
 * BBCatalog and BBShell are ready. It adds through BBShell.tryAddProduct --
 * the same path as the "Add" button on a card -- so the box-full check, the
 * alert and analytics all behave as normal. It never re-adds an item that is
 * already in the box (that would reset its quantity), skips sold-out or
 * unknown items quietly, and takes ?add off the address bar afterwards so a
 * refresh does not add it again. Does nothing while a cart box is being
 * edited (?edit=), because that flow replaces the box after loading.
 */
(function () {
  "use strict";
  var params;
  try { params = new URLSearchParams(window.location.search); } catch (e) { return; }
  var key = params.get("add");
  if (!key) return;

  function cleanUrl() {
    params.delete("add");
    var q = params.toString();
    try {
      history.replaceState(history.state, "", window.location.pathname + (q ? "?" + q : "") + window.location.hash);
    } catch (e) {}
  }

  var S = window.BBStore, C = window.BBCatalog, Sh = window.BBShell;
  if (!S || !C || !Sh || typeof Sh.tryAddProduct !== "function") { cleanUrl(); return; }
  if (params.get("edit") || window.__bbPendingEdit) { cleanUrl(); return; }

  var all = C.all || [];
  var prod = (C.find && C.find(key)) || (C.findByProductId && C.findByProductId(key)) || null;
  if (!prod) {
    for (var i = 0; i < all.length; i++) {
      if (all[i] && (all[i].handle === key || String(all[i].variantId) === key || String(all[i].id) === key)) { prod = all[i]; break; }
    }
  }
  cleanUrl();
  if (!prod || prod.available === false) return;

  var inBox = S.getQty ? S.getQty(prod.variantId) : 0;
  if (!inBox) {
    var st = (S.get && S.get()) || {};
    if ((st.step || 1) !== 1) {
      try {
        if (S.setStep) S.setStep(1);
        if (window.BBSteps && window.BBSteps.showInstant) window.BBSteps.showInstant(1);
      } catch (e) {}
    }
    try { Sh.tryAddProduct(prod, 1, { source: "goodies" }); } catch (e) { return; }
  }

  /* Show them where it went: scroll its card into view (if the grid has
     drawn it yet) and give it a short red glow. */
  var css = document.createElement("style");
  css.textContent =
    "@keyframes bbDeepFlash{0%{box-shadow:0 0 0 0 rgba(202,69,68,.55)}100%{box-shadow:0 0 0 14px rgba(202,69,68,0)}}" +
    "[data-bb-card].bb-deep-flash{animation:bbDeepFlash 1.2s ease-out 2;border-radius:16px}";
  document.head.appendChild(css);
  function flash(tries) {
    var el = document.querySelector('[data-bb-card][data-variant-id="' + prod.variantId + '"]');
    if (el) {
      el.scrollIntoView({ block: "center", behavior: "smooth" });
      el.classList.add("bb-deep-flash");
      setTimeout(function () { el.classList.remove("bb-deep-flash"); }, 2600);
    } else if (tries > 0) {
      setTimeout(function () { flash(tries - 1); }, 250);
    }
  }
  setTimeout(function () { flash(8); }, 300);
})();
